import React, { useState, useEffect } from 'react'
import { supabase } from '../supabase'

const ROUTE_COLS = [
  {dot:'#378ADD',light:'#E6F1FB',text:'#0C447C'},
  {dot:'#1D9E75',light:'#E1F5EE',text:'#085041'},
  {dot:'#7F77DD',light:'#EEEDFE',text:'#3C3489'},
  {dot:'#D85A30',light:'#FAECE7',text:'#4A1B0C'},
]
const MONTHS_ES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']

function getWeekDates(monStr) {
  const mon = new Date(monStr+'T12:00:00')
  const dates = []
  for (let i=0;i<7;i++) {
    const d = new Date(mon); d.setDate(mon.getDate()+i); dates.push(d)
  }
  return dates
}
function dateKey(d) { return d.toISOString().slice(0,10) }
function wkLabel(monStr) {
  const d = new Date(monStr+'T12:00:00')
  const end = new Date(d); end.setDate(d.getDate()+6)
  return `${d.toLocaleDateString('es-MX',{month:'short',day:'numeric'})} – ${end.toLocaleDateString('es-MX',{month:'short',day:'numeric',year:'numeric'})}`
}

export default function Archive() {
  const [weeks, setWeeks] = useState([]) // list of week starts we have data for
  const [selectedWeek, setSelectedWeek] = useState(null)
  const [jobs, setJobs] = useState([])
  const [clients, setClients] = useState([])
  const [staff, setStaff] = useState([])
  const [payroll, setPayroll] = useState([])
  const [history, setHistory] = useState([])
  const [loading, setLoading] = useState(true)
  const [detailLoading, setDetailLoading] = useState(false)
  const [view, setView] = useState('routes') // 'routes' | 'payroll' | 'history'
  const [refreshing, setRefreshing] = useState(false)

  function isCurrentWeek(monStr) {
    const now = new Date()
    const dow = now.getDay()
    const mon = new Date(now)
    mon.setDate(now.getDate() - (dow===0?6:dow-1))
    mon.setHours(0,0,0,0)
    return dateKey(mon) === monStr
  }

  async function refreshWeek() {
    setRefreshing(true)
    await fetchWeekDetail(selectedWeek)
    setRefreshing(false)
  }

  function generateWeekPDF() {
    const weekLabel_str = wkLabel(selectedWeek)
    const totalPay = payroll.reduce((s,p)=>s+parseFloat(p.total_pay||0),0)

    const routeRows = routeData.flatMap(r =>
      r.jobs.map((job,ji) => {
        const client = clients.find(c=>c.id===job.client_id)
        const d = new Date(job.scheduled_date+'T12:00:00')
        return `<tr>
          <td style="padding:6px 10px;border-bottom:1px solid #e3e5e8">
            <span style="display:inline-block;width:18px;height:18px;border-radius:50%;background:${r.rc.dot};color:#fff;text-align:center;line-height:18px;font-size:9px;font-weight:700;margin-right:6px">${ji+1}</span>
            Ruta ${r.label}
          </td>
          <td style="padding:6px 10px;border-bottom:1px solid #e3e5e8">${client?.nickname||client?.name||'?'}</td>
          <td style="padding:6px 10px;border-bottom:1px solid #e3e5e8">${d.toLocaleDateString('es-MX',{weekday:'short',month:'short',day:'numeric'})}</td>
          <td style="padding:6px 10px;border-bottom:1px solid #e3e5e8">${job.start_time||'—'}</td>
          <td style="padding:6px 10px;border-bottom:1px solid #e3e5e8">${job.hours}h</td>
          <td style="padding:6px 10px;border-bottom:1px solid #e3e5e8;color:${job.status==='completed'?'#1d9e75':'#e8547a'}">${job.status==='completed'?'✓ Completada':'Pendiente'}</td>
        </tr>`
      })
    ).join('')

    const payrollRows = payroll.map(p => {
      const s = staff.find(x=>x.id===p.staff_id)
      if (!s) return ''
      let parsed = {}
      try { parsed = JSON.parse(p.notes||'{}') } catch(e) {}
      const totalMi = Object.values(parsed.milesPerDay||{}).reduce((a,b)=>a+(parseFloat(b)||0),0)
      return `<tr>
        <td style="padding:8px 10px;border-bottom:1px solid #e3e5e8;font-weight:500">${s.name}</td>
        <td style="padding:8px 10px;border-bottom:1px solid #e3e5e8">${s.role==='lead'?'Líder':'Miembro'}</td>
        <td style="padding:8px 10px;border-bottom:1px solid #e3e5e8;text-align:center">${p.hours_actual}h</td>
        <td style="padding:8px 10px;border-bottom:1px solid #e3e5e8;text-align:center">${Math.round(totalMi)} mi</td>
        <td style="padding:8px 10px;border-bottom:1px solid #e3e5e8;text-align:right;color:#e8547a;font-weight:600">$${parseFloat(p.total_pay||0).toFixed(2)}</td>
      </tr>`
    }).join('')

    const html = `<!DOCTYPE html>
<html><head><meta charset="utf-8"><title>Semana ${weekLabel_str}</title>
<style>
  body{font-family:Arial,sans-serif;padding:28px;color:#202124;max-width:800px;margin:0 auto}
  h1{font-size:22px;color:#e8547a;margin-bottom:2px}
  .sub{color:#80868b;font-size:12px;margin-bottom:20px}
  .divider{height:2px;background:#e8547a;margin:16px 0}
  h3{font-size:14px;color:#333;margin:18px 0 8px}
  table{width:100%;border-collapse:collapse;font-size:12px}
  th{background:#e8547a;color:#fff;padding:7px 10px;text-align:left}
  .total td{background:#fdeef3;font-weight:700;border-top:2px solid #e8547a}
  @media print{body{padding:14px}}
</style></head><body>
<h1>🌸 Kitty's Cleaning Services</h1>
<div class="sub">Resumen semanal — ${weekLabel_str}</div>
<div class="divider"></div>

<h3>Rutas y limpiezas</h3>
<table>
  <thead><tr><th>Ruta</th><th>Cliente</th><th>Fecha</th><th>Hora</th><th>Duración</th><th>Estado</th></tr></thead>
  <tbody>${routeRows}</tbody>
</table>

<h3>Nómina de la semana</h3>
<table>
  <thead><tr><th>Empleada</th><th>Rol</th><th>Horas</th><th>Millas</th><th>Total</th></tr></thead>
  <tbody>
    ${payrollRows}
    <tr class="total">
      <td colspan="4">Total nómina</td>
      <td style="text-align:right">$${totalPay.toFixed(2)}</td>
    </tr>
  </tbody>
</table>

<h3>Historial de limpiezas</h3>
<table>
  <thead><tr><th>Fecha</th><th>Cliente</th><th>Equipo</th><th>Horas</th><th>Notas</th></tr></thead>
  <tbody>
    ${history.map(h=>{
      const client=clients.find(c=>c.id===h.client_id)
      const d=new Date(h.cleaned_date+'T12:00:00')
      return `<tr>
        <td style="padding:6px 10px;border-bottom:1px solid #e3e5e8">${d.toLocaleDateString('es-MX',{weekday:'short',month:'short',day:'numeric'})}</td>
        <td style="padding:6px 10px;border-bottom:1px solid #e3e5e8">${client?.nickname||client?.name||'?'}</td>
        <td style="padding:6px 10px;border-bottom:1px solid #e3e5e8">${h.staff_names||'—'}</td>
        <td style="padding:6px 10px;border-bottom:1px solid #e3e5e8">${h.hours_actual}h</td>
        <td style="padding:6px 10px;border-bottom:1px solid #e3e5e8">${h.team_note||'—'}</td>
      </tr>`
    }).join('')}
  </tbody>
</table>

<div style="margin-top:24px;font-size:11px;color:#9aa0a6">
  Generado el ${new Date().toLocaleDateString('es-MX',{weekday:'long',year:'numeric',month:'long',day:'numeric'})} · Kitty's Cleaning Services
</div>
<script>window.onload=()=>window.print()</script>
</body></html>`

    const win = window.open('','_blank')
    win.document.write(html)
    win.document.close()
  }

  useEffect(() => { fetchWeeks() }, [])
  useEffect(() => { if (selectedWeek) fetchWeekDetail(selectedWeek) }, [selectedWeek])

  async function fetchWeeks() {
    setLoading(true)
    // Get all distinct week starts from jobs (completed ones)
    const { data } = await supabase
      .from('jobs')
      .select('scheduled_date')
      .eq('status', 'completed')
      .order('scheduled_date', { ascending: false })

    if (data) {
      // Group by week (Monday)
      const weekSet = new Set()
      data.forEach(j => {
        const d = new Date(j.scheduled_date+'T12:00:00')
        const dow = d.getDay()
        const mon = new Date(d)
        mon.setDate(d.getDate() - (dow===0?6:dow-1))
        weekSet.add(dateKey(mon))
      })
      const sorted = [...weekSet].sort((a,b) => b.localeCompare(a))
      setWeeks(sorted)
      if (sorted.length > 0) setSelectedWeek(sorted[0])
    }
    setLoading(false)
  }

  const [routeAssignments, setRouteAssignments] = useState([]) // routes table data with staffIds

  const [signoffs, setSignoffs] = useState([])

  async function fetchWeekDetail(monStr) {
    setDetailLoading(true)
    const endStr = (() => {
      const d = new Date(monStr+'T12:00:00'); d.setDate(d.getDate()+6); return dateKey(d)
    })()
    const [{ data: jb }, { data: cl }, { data: st }, { data: pay }, { data: hist }, { data: rt }, { data: so }] = await Promise.all([
      supabase.from('jobs').select('*').gte('scheduled_date', monStr).lte('scheduled_date', endStr),
      supabase.from('clients').select('id,name,nickname,address,city'),
      supabase.from('staff').select('id,name,role,pay_rate,pay_type'),
      supabase.from('payroll').select('*').gte('period_start', monStr).lte('period_end', endStr),
      supabase.from('cleaning_history').select('*').gte('cleaned_date', monStr).lte('cleaned_date', endStr).order('cleaned_date'),
      supabase.from('routes').select('*').gte('route_date', monStr).lte('route_date', endStr),
      supabase.from('job_signoffs').select('*').gte('scheduled_date', monStr).lte('scheduled_date', endStr),
    ])
    setJobs(jb||[])
    setClients(cl||[])
    setStaff(st||[])
    setPayroll(pay||[])
    setHistory(hist||[])
    setRouteAssignments(rt||[])
    setSignoffs(so||[])
    setDetailLoading(false)
  }

  // Group weeks by month for the sidebar
  const weeksByMonth = weeks.reduce((acc, wk) => {
    const d = new Date(wk+'T12:00:00')
    const key = `${d.getFullYear()}-${d.getMonth()}`
    if (!acc[key]) acc[key] = { label: `${MONTHS_ES[d.getMonth()]} ${d.getFullYear()}`, weeks: [] }
    acc[key].weeks.push(wk)
    return acc
  }, {})

  // Build route summary for selected week — grouped by date
  const routeLabels = [...new Set(jobs.map(j=>j.route).filter(Boolean))].sort()
  const routeData = routeLabels.map((label,ri) => {
    const rc = ROUTE_COLS[ri%ROUTE_COLS.length]
    const routeJobs = jobs.filter(j=>j.route===label).sort((a,b)=>a.scheduled_date.localeCompare(b.scheduled_date)||a.start_time?.localeCompare(b.start_time||'')||0)
    // Get staff from routes table (persisted assignments)
    const routeDates = [...new Set(routeJobs.map(j=>j.scheduled_date))]
    const staffByDate = {}
    routeDates.forEach(dk => {
      const saved = routeAssignments.find(r=>r.label===label&&r.route_date===dk)
      if (saved?.notes) {
        try {
          const p = JSON.parse(saved.notes)
          staffByDate[dk] = (p.staffIds||[]).map(sid=>staff.find(s=>s.id===sid)?.name).filter(Boolean)
        } catch(e) {}
      }
      // Also check cleaning_history for staff names
      if (!staffByDate[dk]?.length) {
        const hist = history.filter(h=>h.cleaned_date===dk&&routeJobs.some(j=>j.client_id===h.client_id))
        if (hist.length) staffByDate[dk] = [hist[0].staff_names]
      }
    })
    return { label, rc, jobs: routeJobs, staffByDate }
  })

  return (
    <div style={s.wrap}>
      <div style={s.topbar}>
        <div style={{fontSize:16,fontWeight:600,color:'#202124'}}>📦 Archivo de rutas y nómina</div>
        <div style={{fontSize:12,color:'#9aa0a6',marginLeft:8}}>{weeks.length} semanas guardadas</div>
        <div style={{marginLeft:'auto',display:'flex',gap:4,alignItems:'center'}}>
          {[['routes','Rutas'],['payroll','Nómina'],['history','Historial']].map(([v,l])=>(
            <button key={v} style={{fontSize:12,padding:'5px 12px',border:'1px solid #e3e5e8',borderRadius:8,cursor:'pointer',
              background:view===v?'#fdeef3':'#fff',color:view===v?'#c03060':'#80868b',fontWeight:view===v?500:400}}
              onClick={()=>setView(v)}>{l}</button>
          ))}
          {selectedWeek && isCurrentWeek(selectedWeek) && (
            <button style={{fontSize:12,padding:'5px 12px',border:'1px solid #e3e5e8',borderRadius:8,background:'#fff',color:'#5f6368',cursor:'pointer'}}
              onClick={refreshWeek} disabled={refreshing}>
              {refreshing?'Actualizando...':'🔄 Actualizar'}
            </button>
          )}
          {selectedWeek && (
            <button style={{fontSize:12,padding:'5px 12px',border:'none',borderRadius:8,background:'#e8547a',color:'#fff',fontWeight:500,cursor:'pointer'}}
              onClick={generateWeekPDF}>
              📄 PDF semana
            </button>
          )}
        </div>
      </div>

      <div style={s.body}>
        {/* WEEK SIDEBAR */}
        <div style={s.sidebar}>
          {loading ? <div style={s.loading}>Cargando...</div> :
            weeks.length===0 ? (
              <div style={s.loading}>
                <div style={{fontSize:14,marginBottom:6}}>📭</div>
                Sin semanas archivadas aún.<br/>
                <span style={{fontSize:10}}>Completa rutas para que aparezcan aquí.</span>
              </div>
            ) :
            Object.entries(weeksByMonth).map(([key, {label, weeks: monthWeeks}]) => (
              <div key={key}>
                <div style={s.monthLabel}>{label}</div>
                {monthWeeks.map(wk => (
                  <div key={wk} style={{...s.weekRow,...(selectedWeek===wk?s.weekRowOn:{})}}
                    onClick={()=>setSelectedWeek(wk)}>
                    <div style={{fontSize:12,fontWeight:selectedWeek===wk?500:400,color:selectedWeek===wk?'#c03060':'#202124'}}>
                      {wkLabel(wk)}
                    </div>
                    <div style={{fontSize:10,color:'#9aa0a6',marginTop:1}}>
                      {jobs.filter(j=>{
                        const d=new Date(j.scheduled_date+'T12:00:00')
                        const dow=d.getDay(); const mon=new Date(d); mon.setDate(d.getDate()-(dow===0?6:dow-1))
                        return dateKey(mon)===wk
                      }).length} limpiezas
                    </div>
                  </div>
                ))}
              </div>
            ))
          }
        </div>

        {/* DETAIL */}
        <div style={s.detail}>
          {!selectedWeek ? (
            <div style={s.empty}><div style={{fontSize:36}}>📦</div><div style={{marginTop:8,color:'#9aa0a6'}}>Selecciona una semana</div></div>
          ) : detailLoading ? (
            <div style={s.empty}><div style={{color:'#9aa0a6'}}>Cargando semana...</div></div>
          ) : (
            <div style={{padding:'16px 20px',overflowY:'auto',height:'100%'}}>
              <div style={{fontSize:16,fontWeight:600,color:'#202124',marginBottom:4}}>{wkLabel(selectedWeek)}</div>
              <div style={{fontSize:12,color:'#9aa0a6',marginBottom:16}}>{jobs.length} limpiezas · {history.length} completadas</div>

              {/* ROUTES VIEW */}
              {view==='routes' && (
                <div style={{display:'flex',flexDirection:'column',gap:12}}>
                  {routeData.length===0 && <div style={{fontSize:13,color:'#9aa0a6'}}>Sin rutas registradas esta semana</div>}
                  {routeData.map(r=>(
                    <div key={r.label} style={{border:`1px solid ${r.rc.dot}33`,borderRadius:12,overflow:'hidden'}}>
                      <div style={{background:r.rc.light,padding:'10px 14px',display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
                        <div style={{width:10,height:10,borderRadius:'50%',background:r.rc.dot}}/>
                        <div style={{fontSize:13,fontWeight:600,color:r.rc.dot}}>Ruta {r.label}</div>
                        <div style={{fontSize:11,color:r.rc.text}}>{r.jobs.length} paradas</div>
                        {/* Show all staff for this route across all days */}
                        {(() => {
                          const allStaff = [...new Set(Object.values(r.staffByDate).flat())]
                          if (allStaff.length > 0) return (
                            <div style={{marginLeft:'auto',display:'flex',gap:4,flexWrap:'wrap'}}>
                              {allStaff.map(name=>(
                                <span key={name} style={{fontSize:10,padding:'2px 8px',borderRadius:10,background:r.rc.dot,color:'#fff',fontWeight:500}}>
                                  {name}
                                </span>
                              ))}
                            </div>
                          )
                          return <div style={{marginLeft:'auto',fontSize:11,color:'#9aa0a6',fontStyle:'italic'}}>Sin equipo registrado</div>
                        })()}
                      </div>
                      {r.jobs.map((job,ji)=>{
                        const client=clients.find(c=>c.id===job.client_id)
                        const d=new Date(job.scheduled_date+'T12:00:00')
                        const dayStaff = r.staffByDate[job.scheduled_date] || []
                        return(
                          <div key={job.id} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 14px',borderBottom:'1px solid #e3e5e8',fontSize:12}}>
                            <div style={{width:20,height:20,borderRadius:'50%',background:r.rc.dot,color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:9,fontWeight:700,flexShrink:0}}>{ji+1}</div>
                            <div style={{flex:1}}>
                              <div style={{fontWeight:500,color:'#202124'}}>{client?.nickname||client?.name||'Cliente'}</div>
                              <div style={{fontSize:10,color:'#80868b'}}>{d.toLocaleDateString('es-MX',{weekday:'short',month:'short',day:'numeric'})} · {job.start_time} · {job.hours}h</div>
                              {dayStaff.length>0&&<div style={{fontSize:10,color:r.rc.dot,marginTop:1}}>👩 {dayStaff.join(' & ')}</div>}
                            </div>
                            {/* Signoff status */}
                            {(() => {
                              const so = signoffs.find(s=>s.job_id===job.id)
                              if (so) return (
                                <div style={{display:'flex',alignItems:'center',gap:6}}>
                                  <span style={{fontSize:10,color:'#1d9e75',fontWeight:500}}>✓ {so.initials}</span>
                                  <button style={{fontSize:10,padding:'2px 8px',border:'1px solid #1d9e75',borderRadius:5,background:'#e1f5ee',color:'#085041',cursor:'pointer'}}
                                    onClick={()=>{
                                      // Generate PDF from saved signoff data
                                      const CHECKLISTS = {
                                        standard:['Vacuuming all rooms','Mopping hard floors','Cleaning bathrooms (toilet, sink, shower/tub)','Wiping kitchen counters & appliances','Cleaning kitchen sink','Dusting surfaces & furniture','Emptying trash bins','Making beds / changing linens','Wiping mirrors & glass','Client walkthrough complete'],
                                        deep:['Everything in Standard Clean','Inside oven cleaned','Inside refrigerator cleaned','Inside cabinets wiped down','Baseboards wiped','Window sills & tracks cleaned','Light fixtures & fans dusted','Walls spot-cleaned','Behind/under furniture cleaned','Detailed bathroom grout scrubbing','Client walkthrough complete'],
                                        airbnb:['All linens changed & beds made hotel-style','Bathrooms fully sanitized','Kitchen cleaned & dishes put away','All trash removed','Floors vacuumed & mopped','Surfaces wiped & disinfected','Toiletries restocked (if provided)','Check for guest left items','Welcome setup complete (if applicable)','Photos taken of completed rooms','Client walkthrough complete'],
                                        moveout:['All rooms vacuumed & mopped','Inside all cabinets & drawers cleaned','Inside oven & refrigerator cleaned','Bathrooms deep cleaned & sanitized','All walls spot-cleaned','Baseboards & trim wiped','Windows cleaned inside','All trash & debris removed','Light fixtures cleaned','Garage/patio swept (if applicable)','Final walkthrough with all rooms checked'],
                                      }
                                      const TYPE_LABELS = {standard:'🧹 Standard Clean',deep:'🫧 Deep Clean',airbnb:'🏠 Airbnb Turnover',moveout:'📦 Move-Out Clean'}
                                      const checkItems = CHECKLISTS[so.clean_type]||CHECKLISTS.standard
                                      const dateLabel = new Date(so.scheduled_date+'T12:00:00').toLocaleDateString('en-US',{weekday:'long',month:'long',day:'numeric',year:'numeric'})
                                      const rows = checkItems.map(item=>`<tr><td style="padding:7px 10px;border-bottom:1px solid #e3e5e8;font-size:12px">${item}</td><td style="padding:7px 10px;border-bottom:1px solid #e3e5e8;text-align:center"><span style="font-size:16px;color:${(so.checked_items||[]).includes(item)?'#1d9e75':'#ddd'}">${(so.checked_items||[]).includes(item)?'✓':'○'}</span></td></tr>`).join('')
                                      const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Cleaning Verification</title><style>body{font-family:Arial,sans-serif;padding:32px;color:#202124;max-width:680px;margin:0 auto}.header{background:#e8547a;color:#fff;padding:18px 24px;border-radius:10px 10px 0 0;display:flex;justify-content:space-between;align-items:center;-webkit-print-color-adjust:exact;print-color-adjust:exact}.body{border:2px solid #e8547a;border-top:none;border-radius:0 0 10px 10px;padding:20px 24px}table{width:100%;border-collapse:collapse;margin-bottom:20px}th{background:#e8547a;color:#fff;padding:8px 10px;text-align:left;font-size:11px;-webkit-print-color-adjust:exact;print-color-adjust:exact}td{padding:7px 10px;border-bottom:1px solid #e3e5e8;font-size:12px}.sig{border:1.5px solid #e8547a;border-radius:10px;padding:16px;margin-top:16px}</style></head><body><div class="header"><div><b>Kitty's Cleaning Services 🐈</b><br><small>6427 Wilcox Ave, Bell, CA 90201</small></div><div style="text-align:right">Cleaning Verification<br><small>Route ${so.route_label}</small></div></div><div class="body"><p><b>Client:</b> ${client?.name||'Client'}<br><b>Address:</b> ${client?.address||''}<br><b>Date:</b> ${dateLabel}<br><b>Type:</b> ${TYPE_LABELS[so.clean_type]||''}</p><br><table><thead><tr><th>Task</th><th style="width:60px;text-align:center">Done</th></tr></thead><tbody>${rows}</tbody></table>${so.notes?`<p><b>Notes:</b> ${so.notes}</p>`:''}<div class="sig"><b>Signed by:</b> <span style="font-size:24px;color:#e8547a;font-family:Georgia,serif">${so.initials}</span><br><small>Signed at: ${new Date(so.signed_at).toLocaleString('en-US')}</small></div></div><script>window.onload=()=>window.print()</script></body></html>`
                                      const win=window.open('','_blank'); win.document.write(html); win.document.close()
                                    }}>
                                    📄 PDF
                                  </button>
                                </div>
                              )
                              return <span style={{fontSize:10,color:'#9aa0a6'}}>Sin firma</span>
                            })()}
                            <div style={{fontSize:11,color:job.status==='completed'?'#1d9e75':'#e8547a',fontWeight:500}}>
                              {job.status==='completed'?'✓':'Pendiente'}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  ))}
                </div>
              )}

              {/* PAYROLL VIEW */}
              {view==='payroll' && (
                <div style={{display:'flex',flexDirection:'column',gap:10}}>
                  {payroll.length===0 && <div style={{fontSize:13,color:'#9aa0a6'}}>Sin datos de nómina esta semana</div>}
                  {payroll.map(p=>{
                    const s = staff.find(x=>x.id===p.staff_id)
                    if (!s) return null
                    let parsed = {}
                    try { parsed = JSON.parse(p.notes||'{}') } catch(e) {}
                    const milesPerDay = parsed.milesPerDay || {}
                    const totalMi = Object.values(milesPerDay).reduce((a,b)=>a+(parseFloat(b)||0),0)
                    return(
                      <div key={p.id} style={{background:'#fff',borderRadius:12,border:'1px solid #e3e5e8',padding:'14px 16px'}}>
                        <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:10}}>
                          <div style={{width:36,height:36,borderRadius:'50%',background:'#fdeef3',color:'#c03060',display:'flex',alignItems:'center',justifyContent:'center',fontSize:14,fontWeight:600}}>
                            {s.name[0]}
                          </div>
                          <div style={{flex:1}}>
                            <div style={{fontSize:14,fontWeight:600,color:'#202124'}}>{s.name}</div>
                            <div style={{fontSize:11,color:'#9aa0a6'}}>
                              {s.role==='lead'?'Líder':'Miembro'} · 
                              {parsed.rateSnapshot ? ` $${parsed.rateSnapshot}${parsed.payTypeSnapshot==='hourly'?'/hr':'/sem'} (esa semana)` : ` $${s.pay_rate}${s.pay_type==='hourly'?'/hr':'/sem'}`}
                            </div>
                          </div>
                          <div style={{textAlign:'right'}}>
                            <div style={{fontSize:20,fontWeight:700,color:'#e8547a'}}>${parseFloat(p.total_pay||0).toFixed(2)}</div>
                            <div style={{fontSize:10,color:'#9aa0a6'}}>{p.hours_actual}h · {Math.round(totalMi)} mi</div>
                          </div>
                        </div>
                        {parsed.note&&<div style={{fontSize:11,color:'#5f6368',fontStyle:'italic',padding:'6px 8px',background:'#f8f9fa',borderRadius:6}}>{parsed.note}</div>}
                      </div>
                    )
                  })}
                  {payroll.length>0&&(
                    <div style={{padding:'12px 16px',background:'#fdf0f3',borderRadius:10,display:'flex',justifyContent:'space-between',fontSize:14,fontWeight:600}}>
                      <span>Total nómina semana</span>
                      <span style={{color:'#e8547a'}}>${payroll.reduce((s,p)=>s+parseFloat(p.total_pay||0),0).toFixed(2)}</span>
                    </div>
                  )}
                </div>
              )}

              {/* HISTORY VIEW */}
              {view==='history' && (
                <div>
                  {history.length===0 && <div style={{fontSize:13,color:'#9aa0a6'}}>Sin historial registrado esta semana</div>}
                  {history.map(h=>{
                    const client=clients.find(c=>c.id===h.client_id)
                    return(
                      <div key={h.id} style={{display:'flex',alignItems:'flex-start',gap:10,padding:'10px 0',borderBottom:'1px solid #e3e5e8'}}>
                        <div style={{width:44,textAlign:'center',flexShrink:0}}>
                          <div style={{fontSize:13,fontWeight:600,color:'#202124'}}>{new Date(h.cleaned_date+'T12:00:00').getDate()}</div>
                          <div style={{fontSize:10,color:'#9aa0a6'}}>{new Date(h.cleaned_date+'T12:00:00').toLocaleDateString('es-MX',{month:'short'})}</div>
                        </div>
                        <div style={{flex:1}}>
                          <div style={{fontSize:13,fontWeight:500,color:'#202124'}}>{client?.nickname||client?.name||'Cliente'}</div>
                          <div style={{fontSize:11,color:'#80868b'}}>{h.staff_names} · {h.hours_actual}h</div>
                          {h.team_note&&<div style={{fontSize:11,color:'#5f6368',fontStyle:'italic'}}>{h.team_note}</div>}
                        </div>
                        <div style={{fontSize:11,color:'#1d9e75',fontWeight:500}}>✓</div>
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const s = {
  wrap:{display:'flex',flexDirection:'column',height:'100%',overflow:'hidden'},
  topbar:{display:'flex',alignItems:'center',gap:8,padding:'12px 16px',borderBottom:'1px solid #e3e5e8',background:'#fff',flexShrink:0},
  body:{display:'flex',flex:1,overflow:'hidden'},
  sidebar:{width:200,borderRight:'1px solid #e3e5e8',overflowY:'auto',background:'#f8f9fa',flexShrink:0},
  loading:{padding:16,fontSize:12,color:'#9aa0a6',textAlign:'center',lineHeight:1.6},
  monthLabel:{fontSize:10,fontWeight:600,textTransform:'uppercase',letterSpacing:'.06em',color:'#9aa0a6',padding:'10px 12px 4px'},
  weekRow:{padding:'8px 12px',cursor:'pointer',borderBottom:'1px solid #e3e5e8'},
  weekRowOn:{background:'#fff',borderLeft:'3px solid #e8547a'},
  detail:{flex:1,overflow:'hidden',display:'flex',flexDirection:'column'},
  empty:{flex:1,display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',color:'#80868b',fontSize:13},
}
